import { State } from 'src/types'
import { thumbHook } from 'src/features/dxm/drawer/rightThrow/catcher/back/thumbHook'
import { littleHook } from 'src/features/dxm/drawer/rightThrow/catcher/back/littleHook'
import { laceDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/back/lace'
import { backStyleDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/back/backStyleDrawer'
import { canvasResetter } from 'src/util/canvas'
import { catchFaceDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/back/catchFaceDrawer'
import { webDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/back/webDrawer'
import { fingerGuardDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/back/fingerGuardDrawer'
import { startInversion, undoInversion } from 'src/util/canvas'
import { liningDrawerLeftThrow } from 'src/features/dxm/drawer/leftThrow/catcher/back/liningDrawer'
import { fingerEmbroideryDrawerLeftThrow } from 'src/features/dxm/drawer/leftThrow/catcher/back/fingerEmbroideryDrawer'
import { dxmLabel } from 'src/features/dxm/drawer/rightThrow/glove/back/label'

export const dxmCanvasCatcherMittBackLeftThrow = (ctx: CanvasRenderingContext2D, state: State, canvasWidth: number): void => {
  // リセット
  canvasResetter(ctx)

  // 裏革
  liningDrawerLeftThrow(ctx, state, canvasWidth)
  startInversion(ctx, canvasWidth)

  // バックスタイル
  backStyleDrawer(ctx, state)

  // 捕球面側
  catchFaceDrawer(ctx, state.catchFace.color, state.stitch.color, state.baseModel.productNumber)

  // 指カバー・指当て
  fingerGuardDrawer(ctx, state)
  undoInversion(ctx, canvasWidth)

  // 親指、小指の刺繍
  fingerEmbroideryDrawerLeftThrow(ctx, state.embroideries, state.backStyle)
  startInversion(ctx, canvasWidth)
  // ウェブ
  webDrawer(ctx, state)

  // 革紐
  laceDrawer(ctx, state.lace.color)

  // かけ紐
  thumbHook(ctx, state.thumbHook.color)
  littleHook(ctx, state.littleHook.color)

  undoInversion(ctx, canvasWidth)
  // ブランドのラベル
  dxmLabel(ctx, state, 210, 45, 7, 0.9)
}
